<script setup>
defineProps({
  /** Array of { label, value, strong, mono } */
  items: { type: Array, required: true },
  /** light, dark or tint (for peach and tint tiles) */
  surface: { type: String, default: 'light' },
  /** Shows the last row as a bold total with a heavier rule above */
  total: { type: Boolean, default: false },
});
</script>

<template>
  <dl class="pd-kv" :class="[`pd-kv--${surface}`, { 'has-total': total }]">
    <div v-for="it in items" :key="it.label" class="pd-kv__row">
      <dt>{{ it.label }}</dt>
      <dd :class="{ 'is-strong': it.strong, 'pd-num': it.mono !== false }">
        <slot :name="it.slot || it.label" :item="it">{{ it.value }}</slot>
      </dd>
    </div>
  </dl>
</template>

<style scoped>
.pd-kv { margin: 0; }
.pd-kv__row { display: flex; justify-content: space-between; align-items: baseline; gap: 20px; padding: 14px 0; border-bottom: 1px solid var(--pd-line); }
.pd-kv dt { color: var(--pd-muted); font-size: 0.9375rem; }
.pd-kv dd { margin: 0; text-align: right; font-weight: 800; overflow-wrap: anywhere; }
.pd-kv dd.is-strong { font-size: 1.125rem; }
.has-total .pd-kv__row:last-child { border-bottom: 0; border-top: 1px solid var(--pd-line-active); margin-top: -1px; padding-top: 18px; }
.has-total .pd-kv__row:last-child dt { color: var(--pd-ink); font-weight: 800; }
.has-total .pd-kv__row:last-child dd { font-size: 1.5rem; letter-spacing: -0.03em; }
.pd-kv--dark .pd-kv__row { border-color: var(--pd-ink-line); }
.pd-kv--dark dt { color: var(--pd-ink-muted); }
.pd-kv--dark.has-total .pd-kv__row:last-child { border-top-color: var(--pd-orange); }
.pd-kv--dark.has-total .pd-kv__row:last-child dt { color: var(--pd-white); }
</style>
<style scoped>
.pd-kv--tint .pd-kv__row { border-color: var(--pd-line-strong); }
.pd-kv--tint dt { color: var(--pd-ink); opacity: 0.7; }
</style>
